import fr from 'locales/fr';
import en from 'locales/en';

const locales = {
    en,
    fr,
};

export default locales;
